import React, { useEffect, useState } from 'react';
import Modal from '../../molecules/Modal';
import Textbox from '../../atoms/Textbox';
import { Link } from 'react-router-dom';
import Dropdown from '../../atoms/Dropdown';
import { VisitReservationStoreInfo } from '../../../redux/reducers/VisitReservationInfoReducer';
import { getCompanyCfcDisplayName } from '../../../Common';

export interface VisitStoreSelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  storeList: VisitReservationStoreInfo[];
  updateTargetStore: (targetStores: VisitReservationStoreInfo[]) => void;
}

/**
 * 来店予約の店舗選択モーダル
 */
const VisitStoreSelectModal: React.FC<VisitStoreSelectModalProps> = ({ isOpen, onClose, storeList, updateTargetStore }) => {
  const [anchorEl, setAnchorEl] = useState<(EventTarget & HTMLInputElement) | null>(null);
  const [searchValue, setSearchValue] = useState('');
  const [filteredStoreList, setFilteredStoreList] = useState<Array<VisitReservationStoreInfo>>(storeList);
  const inputRef = React.createRef<HTMLInputElement>();

  const onCloseWithEscapeKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Escape') {
      setAnchorEl(null);
    }
  };

  const isKeywordsMatch = (src: string, keywords: string[]): boolean => {
    let result = true;
    keywords.forEach((keyword) => {
      if (src.indexOf(keyword) < 0) {
        result = false;
      }
    });
    return result;
  };

  const onClick = (agencyCd: string) => {
    updateTargetStore(storeList.filter((store) => store.chkdegtOrdcstmCd === agencyCd));
    setAnchorEl(null);
  };

  useEffect(() => {
    const keywords: string[] = searchValue.split(' ').filter((v: string) => v);
    setFilteredStoreList(
      storeList.filter((store: VisitReservationStoreInfo) =>
        isKeywordsMatch(getCompanyCfcDisplayName(store.companyCfc, store.longNm), keywords)
      )
    );
  }, [searchValue]);

  const renderSuggestion = () => {
    return (
      <div className='' style={{ width: 720, maxWidth: '100%' }}>
        <Textbox
          inputRef={inputRef}
          leftIcon='search'
          wrapperClass='filter-modal__textbox u-w-full'
          value={searchValue}
          placeholder='検索'
          onChange={(e) => setSearchValue(e.target.value)}
          data-testid='visit-store-select-modal--filter-search-text-box'
        />
        {/* 検索結果リスト */}
        <ul className='list'>
          <li className='filter-modal__header-title' data-testid='visit-store-select-modal--filter-agency-count'>
            取次店 ({filteredStoreList.length}件)
          </li>
          {filteredStoreList.map((storeInfo: VisitReservationStoreInfo) => (
            <li key={storeInfo.chkdegtOrdcstmCd} className='list__item-link list__item-link--has-left-icon'>
              <Link
                to='#'
                onClick={() => {
                  onClick(storeInfo.chkdegtOrdcstmCd);
                }}
                data-testid='visit-store-select-modal--filter-agency-link'>
                {getCompanyCfcDisplayName(storeInfo.companyCfc, storeInfo.longNm)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <Modal
      className='filter-modal'
      open={isOpen}
      hasFade={false}
      surfaceClassName='u-mv-auto'
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}>
      <Modal.Header hasCloseButton={true} onClickClose={onClose} data-testid='visit-store-select-modal--header'>
        <span className='u-mr16 u-text-middle' data-testid='visit-store-select-modal--header-title'>
          表示店舗
        </span>
      </Modal.Header>
      <Modal.Content>
        <Dropdown
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          popover={renderSuggestion()}
          onKeyDown={(e) => onCloseWithEscapeKeyDown(e)}
          onEnter={() => {
            inputRef.current && inputRef.current.focus();
          }}
          onBackdropClick={() => setAnchorEl(null)}
          transitionDuration={0}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}>
          <div className='uc-divider' />
          <Textbox
            readOnly
            leftIcon='search'
            wrapperClass='filter-modal__textbox u-w-full'
            value={searchValue}
            placeholder='検索'
            onClick={(e) => {
              setAnchorEl(e.currentTarget);
            }}
            data-testid='visit-store-select-modal--search-text-box'
          />
        </Dropdown>

        <div data-testid='visit-store-select-modal--list-head-title' className='filter-modal__header-title'>
          取次店 ({storeList.length}件)
        </div>
        <div className='filter-modal__drilldown-item' data-testid='visit-store-select-modal--store-list'>
          <div className='filter-modal__scroll-area'>
            <ul className='list'>
              {storeList.map((store) => (
                <li className='list__item-link list__item-link--has-left-icon' data-testid='visit-store-select-modal--store-list'>
                  <Link
                    to='#'
                    onClick={() => {
                      updateTargetStore([store]);
                    }}>
                    {getCompanyCfcDisplayName(store.companyCfc, store.longNm)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default VisitStoreSelectModal;
